// InflationCalculator.js
import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE = "Kalkulator Dampak Inflasi terhadap Uang";
const DESCRIPTION =
  "Kalkulator dampak inflasi menghitung jumlah uang yang kehilangan nilainya akibat inflasi antara dua periode waktu yang berbeda.";
const KEYWORDS = "dampak inflasi terhadap uang, hitung dampak inflasi, kalkulator inflasi";
const OG_URL = "https://do-calculate.com/calculator/id/inflation";
function InflationCalculator() {
  const [initialAmount, setInitialAmount] = useState("");
  const [initialDollarRate, setInitialDollarRate] = useState("");
  const [finalDollarRate, setFinalDollarRate] = useState("");
  const [result, setResult] = useState("");
  const [error, setError] = useState("");
  const handleCalculate = () => {
    if (!initialAmount || !initialDollarRate || !finalDollarRate) {
      setError("Harap masukkan semua nilai dengan benar");
      setResult("");
      return;
    }
    const initialAmountValue = parseFloat(initialAmount);
    const initialDollarRateValue = parseFloat(initialDollarRate);
    const finalDollarRateValue = parseFloat(finalDollarRate);
    if (
      isNaN(initialAmountValue) ||
      isNaN(initialDollarRateValue) ||
      isNaN(finalDollarRateValue)
    ) {
      setError("Harap masukkan nilai angka yang valid");
      setResult("");
      return;
    }
    const initialValueInDollars = initialAmountValue / initialDollarRateValue;
    const finalValueInDollars = initialAmountValue / finalDollarRateValue;
    const lossInDollars = initialValueInDollars - finalValueInDollars;
    const lossPercentage = (lossInDollars / initialValueInDollars) * 100;
    setResult(
      `Jumlah awal dalam dolar: ${initialValueInDollars.toFixed(2)} dolar <br/>
            Nilai setelah inflasi dalam dolar: ${finalValueInDollars.toFixed(
              2
            )} dolar <br/>
            Kerugian dalam dolar: ${lossInDollars.toFixed(2)} dolar <br/>
            Persentase kerugian: ${lossPercentage.toFixed(2)}%`
    );
    setError("");
  };
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <h2 style={{ fontSize: "18px" }}>Cara Menghitung Dampak Inflasi</h2>
                <p>
                  Cara menghitung dampak inflasi adalah dengan menghitung selisih nilai uang antara dua periode berbeda berdasarkan tingkat inflasi.
                </p>
                <p>Kerugian = Jumlah awal - Nilai setelah inflasi</p>
                <p>Persentase kerugian = (Kerugian / Jumlah awal) × 100%</p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE} </h2>
                </div>
                <hr />
                <div >
                  <div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">Jumlah Awal</label>
                      </b>
                      <input
                        type="number"
                        placeholder="10000"
                        value={initialAmount}
                        onChange={(e) => setInitialAmount(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          Nilai jumlah awal dalam dolar
                        </label>
                      </b>
                      <input
                        type="number"
                        placeholder="30"
                        value={initialDollarRate}
                        onChange={(e) => setInitialDollarRate(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          Nilai jumlah awal dalam dolar pada periode kedua
                        </label>
                      </b>
                      <input
                        type="number"
                        placeholder="40"
                        value={finalDollarRate}
                        onChange={(e) => setFinalDollarRate(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      Hitung Dampak Inflasi
                    </button>
                  </div>
                  <br />
                  <div>
                    {error !== "" ? (
                      <p className="p-3 mb-2 bg-warning text-white">
                        Error: {error}
                      </p>
                    ) : (
                      <>
                        {result !== "" && (
                          <>
                            <p className="p-3 mb-2 bg-success text-white">
                              Hasil:
                            </p>
                            <p
                              className="p-3 mb-2 bg-info text-black"
                              dangerouslySetInnerHTML={{ __html: result }}
                            ></p>
                          </>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList CalculatorsTypeId={500}></MainCalculatorsList>
          <br />
        </div>
      </div>
      {" "}
      <br />
    </div>
  );
}
export default InflationCalculator;